import _ from 'lodash';
import { useEffect } from 'react';
import {
  getRepoModalTableData,
  getActiveRepositories,
  getRepoModalTableColumns
} from './repositories-modal.service';

const useOwnerRepositories = ({
  providerConfig,
  repositories,
  selected,
  isOnboarding,
  isCheckboxDisabled,
  toggleRepositorySelection,
  numOfSelectableRepos,
  setSelected,
  isOpen
}) => {
  const localSelected = repositories
    .map(({ id }) => id)
    .filter(id => selected.has(id)).length;

  const orderedRepositories = _.chain(repositories)
    .orderBy(['updated_at', 'owner_type'], ['desc', 'asc'])
    .value();

  const data = getRepoModalTableData({
    providerConfig,
    numOfSelectableRepos,
    selected,
    filteredRepositories: orderedRepositories,
    isOnboarding,
    isCheckboxDisabled,
    toggleRepositorySelection
  });

  const selectAll = () => {
    const newSelected = new Set([
      ...getActiveRepositories(orderedRepositories)
        .map(({ id }) => id)
        .slice(0, numOfSelectableRepos),
      ...selected
    ]);
    setSelected(newSelected);
  };

  const unselectAll = () => {
    const repositoriesIds = new Set(repositories.map(({ id }) => id));
    const newSelected = new Set(
      [...selected].filter(id => !repositoriesIds.has(id))
    );
    setSelected(newSelected);
  };

  const numOfActiveRepositories = getActiveRepositories(repositories).length;
  const columns = getRepoModalTableColumns({
    numOfActiveRepositories
  });

  useEffect(() => {
    if (isOpen && isOnboarding) {
      selectAll();
    }
  }, []);

  return {
    columns,
    numOfActiveRepositories,
    unselectAll,
    selectAll,
    data,
    localSelected
  };
};

export default useOwnerRepositories;
